<template>
  <div class="content">
    <PulseLoader
      :loading="loading"
      :class="{ hide: !loading }"
      quote="Action is the foundational key to all success"
      author="Pablo Picasso"
      profession="Spanish Painter"
      img="picasso.jpg"
    ></PulseLoader>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <nav aria-label="breadcrumb" role="navigation" class="m-0">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: defaultScreen }"> Home</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Reports
            </li>
          </ol>
        </nav>
        <div class="navbar md-toolbar md-transparent md-elevation-4">
          <div class="md-toolbar-section-start">
            <h1 class="section_header">Reports</h1>
          </div>
          <div class="md-toolbar-section-end filter_btn">
            <div class="md-collapse">
              <ul class="md-list md-theme-default">
                <li href="#" class="md-list-item">
                  <a
                    mdripple="true"
                    href="#"
                    class="md-list-item-link md-list-item-container md-button-clean"
                    @click="switchView('card')"
                    ><div class="md-list-item-content md-ripple">
                      <i class="material-icons">dashboard</i>
                      <p class="hidden-lg hidden-md" hidden>Dashboard</p>
                    </div></a
                  >
                </li>
                <li href="#" class="md-list-item">
                  <a
                    mdripple="true"
                    href="#"
                    class="md-list-item-link md-list-item-container md-button-clean"
                    @click="switchView('list')"
                    ><div class="md-list-item-content md-ripple">
                      <i class="material-icons">reorder</i>
                    </div></a
                  >
                </li>
              </ul>
            </div>
            <div class="links" style="max-width:nullpx;">
              <div class="search-box">
                <input
                  aria-label="Search"
                  autocomplete="off"
                  spellcheck="false"
                  v-model="searchInput"
                  placeholder="Search reports..."
                  @input="searchProfile(searchInput)"
                />
              </div>
            </div>
            <!--<div class="datepicker-box">
              <datetime
                format="MM/DD/YYYY"
                width="300px"
                v-model="date"
                @input="searchProfileDate(date)"
              ></datetime>
            </div> -->
            <div
              type="button"
              class="md-button md-just-icon md-simple md-toolbar-toggle md-theme-default"
            >
              <div class="md-ripple">
                <div class="md-button-content">
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <zoom-center-transition :duration="200" mode="out-in">
      <div v-if="view === 'card'" class="md-layout my_report">
        <!-- <pulse-loader
          class="loading"
          :color="'blue'"
          :loading="loading"
        ></pulse-loader> -->
        <div
          v-for="(card, index) in apiData"
          :key="index"
          class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
        >
          <router-link
            :to="{
              name: routingOptions[card.type],
              params: { id: card.id },
            }"
          >
            <profile-card header-color="blue">
              <template slot="header">
                <div class="card-icon"><md-icon>assessment</md-icon></div>
                <span class="category">{{ card.title }}</span>
                <i class="md-icon">more_horiz</i>
              </template>
              <template slot="content">
                <!-- <div class="company_tag"><span>Client: ABC Plumbing</span></div> -->
                <p class="dark-blue-color"><i class="md-icon">business_center</i>Industry</p>
                <p>
                  {{
                    `${card.bznaics ? `[${card.bznaics}]` : ''} ${
                      card.industry ? card.industry : ''
                    }`
                  }}
                </p>
                <p class="dark-blue-color" v-if="card.area">
                  <i class="md-icon">place</i>Market Area:
                </p>
                <p>{{ card.area ? card.area : '' }}</p>
                <p class="dark-blue-color"><i class="md-icon">equalizer</i>Sales Classes:</p>
                <p v-if="card.salesClass">
                  {{
                    card.salesClass
                      ? `Sales Class: ${card.salesClass} ${
                          card.years ? `(${card.years})` : ''
                        }`
                      : ''
                  }}
                </p>
                <p class="dark-blue-color"><i class="md-icon">watch_later</i>Release Date:</p>
                <p>{{ card.release ? card.release : '' }}</p>
              </template>
              <template slot="footer">
                <div class="stats">
                  <avatar class="user-avatar" v-if="!auth_user.user.avatar" :size="35" :inline="true" backgroundColor="#b8c3d0" :username="auth_user.user.firstName + ' ' + auth_user.user.lastName"></avatar>
                  <img
                    v-if="auth_user.user.avatar"
                    class="user-avatar"
                    :src="auth_user.user.avatar"
                  />
                  <span class="date ml-10"
                    >Created: {{ card.created }}</span
                  >
                  <span v-if="card.update" class="update-available">
                    <md-icon>new_releases</md-icon>
                    Update
                  </span>
                </div>
                <a class="more_btn"><i class="md-icon">double_arrow</i></a>
              </template>
            </profile-card>
          </router-link>
        </div>
      </div>
    </zoom-center-transition>
    <zoom-center-transition :duration="200" mode="out-in">
      <div v-if="view === 'list'" class="md-layout my_report">
        <PulseLoader
          :loading="loading"
          :class="{ hide: !loading }"
          quote="Action is the foundational key to all success"
          author="Pablo Picasso"
          profession="Spanish Painter"
          img="picasso.jpg"
        ></PulseLoader>
        <!-- <pulse-loader
          class="loading"
          :color="'blue'"
          :loading="loading"
        ></pulse-loader> -->
        <div class="md-layout-item md-size-100">
          <table-card class="my_report_tbl">
            <template slot="header"> </template>

            <template slot="content">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 p-0">
                  <md-table v-model="apiData" table-header-color="blue">
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="">
                        <router-link
                          class="link"
                          :to="{
                            name: routingOptions[item.type],
                            params: { id: item.id },
                          }"
                        >
                          <md-icon>double_arrow</md-icon>
                        </router-link>
                      </md-table-cell>
                      <md-table-cell md-label="Date Created">{{
                        item.created ? item.created : 'N/A'
                      }}</md-table-cell>
                      <md-table-cell
                        class="profile_title"
                        md-label="Profile Type"
                        >{{ item.title ? item.title : 'N/A' }}</md-table-cell
                      >
                      <md-table-cell md-label="Industry">{{
                        `${item.bznaics ? `[${item.bznaics}]` : 'N/A'} ${
                          item.industry ? item.industry : 'N/A'
                        }`
                      }}</md-table-cell>
                      <md-table-cell md-label="Market Area">{{
                        item.area ? item.area : 'N/A'
                      }}</md-table-cell>
                      <md-table-cell md-label="Release"
                        >{{ item.release ? item.release : 'N/A' }}
                        <md-icon v-if="item.update" class="new-release-icon"
                          >new_releases</md-icon
                        ></md-table-cell
                      >
                    </md-table-row>
                  </md-table>
                </div>
              </div>
            </template>
          </table-card>
        </div>
      </div>
    </zoom-center-transition>

    <div class="md-layout paginationWpr">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <div class="navbar md-toolbar md-transparent md-elevation-4">
          <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
              <div v-show="!loading" class="pagin-page-info">
                Showing page:
                {{ pagination.currentPage }}
                of {{ pagination.total }}
              </div>
            </div>
            <div v-show="!loading" class="md-toolbar-section-end">
              <pagination
                class="pagination-no-border pagination-info"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total * pagination.perPage"
                @click.native="getPages()"
              >
              </pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProfileCard, Pagination, TableCard } from '@/components';
import datetime from 'vuejs-datetimepicker';
import axios from 'axios';
import { mapState } from 'vuex';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import { PulseLoader } from '@/components';
import Avatar from 'vue-avatar';

export default {
  name: 'my-reports',
  components: {
    ProfileCard,
    Pagination,
    TableCard,
    //datetime,
    PulseLoader,
    Avatar
  },
  data() {
    return {
      pagination: {
        perPage: 24,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: undefined,
      },
      view: undefined,
      date: '',
      apiData: [],
      searchResult: [],
      searchDateResult: [],
      clearSearchData: [],
      searchInput: '',
      loading: true,
      routingOptions: {
        imr: 'MRAboutTheData',
        cma: 'MRAboutTheData',
        if: 'IFAboutTheData',
        mf: 'SPIFAboutTheData',
        vpro: 'VRAbouttheData',
        swot: 'CRAbouttheData',
        lmr: 'MRAboutTheData',
      },
      userImage: '',
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
    }),
  },
  methods: {
    switchView: function(type) {
      localStorage.setItem('my_reports_save_option', type);
      this.view = type;
    },
    searchProfile: function(searchInput) {
      this.apiData = this.clearSearchData;
      if (searchInput) {
        this.apiData = [];
        this.clearSearchData.forEach((profile) => {
          if (
            Object.values(profile).some((value) => {
              if (!value) {
                return;
              }
              return value
                .toString()
                .toLowerCase()
                .includes(this.searchInput.toString().toLowerCase());
            })
          ) {
            this.apiData.push(profile);
          }
        });
      }
      this.searchResult = this.apiData;
      let tmp = this.searchResult.filter((value) =>
        this.searchDateResult.includes(value)
      );
      this.apiData = tmp;
    },

    searchProfileDate: function(dateInput) {
      this.apiData = this.clearSearchData;
      if (dateInput) {
        this.apiData = [];
        this.clearSearchData.forEach((profile) => {
          const profileDate = new Date(profile.created);
          const inputDate = new Date(dateInput);
          if (profileDate.getTime() === inputDate.getTime()) {
            this.apiData.push(profile);
          }
        });
      }
      this.searchDateResult = this.apiData;
      let tmp = this.searchDateResult.filter((value) =>
        this.searchResult.includes(value)
      );
      this.apiData = tmp;
    },

    getPages: async function() {
      this.apiData = [];
      this.loading = true;
      const options = {
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
        },
      };
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/fetch_reports',
          {},
          {
            params: {
              session_id: currentSession,
              page: this.pagination.currentPage,
              itemsPerPage: this.pagination.perPage,
            },
          },
          options
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/fetch_reports" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { totalPages, records } = res.data;

          this.pagination.total = totalPages;
          for (var record in Object.keys(records)) {
            if(records.length>0)
              this.apiData.push(records[record]);
          }
          this.clearSearchData = this.apiData;
          this.searchResult = this.apiData;
          this.searchDateResult = this.apiData;
          this.loading = false;
        });
    },
    getAuth() {
      return this.$store.dispatch('authenticateUser').then((res) => {
        this.userImage = res.avatar ? res.avatar : '';
      });
    },
  },
  async created() {
    this.getAuth();
    if (localStorage.getItem('my_reports_save_option') === null) {
      this.view = 'card';
    } else {
      this.view = localStorage.getItem('my_reports_save_option');
    }
    await this.getPages();
  },
};
</script>
<style lang="scss">
.loading {
  position: absolute;
  left: 45%;
}

.my_report .md-card-profile .md-card-actions .more_btn i {
  background-color: #7041e5 !important;
  height: 41% !important;
}
</style>
